import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ff37ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbview" }
const _hoisted_2 = { style: {"font-size":"16px","color":"#999"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 当前位置： ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"fixed","right":"30px","top":"60px","z-index":"1029"} }, null, -1))

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.breadcrumblist, (item, index) => {
        return (_openBlock(), _createElementBlock("span", {
          onClick: $event => ($options.linkTo(item.route)),
          key: index,
          style: _normalizeStyle([{"cursor":"pointer"}, index == $props.breadcrumblist.length - 1 ? 'color:#3E6FF5' : ''])
        }, _toDisplayString(index != 0 ? ' / ' : '') + _toDisplayString(item.name), 13, _hoisted_4))
      }), 128))
    ]),
    _hoisted_5
  ]))
}